import { render, staticRenderFns } from "./SuggestInEditBusiness.vue?vue&type=template&id=0024908c&"
import script from "./SuggestInEditBusiness.vue?vue&type=script&lang=js&"
export * from "./SuggestInEditBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports